(() => {
  const config = window.upsellCheckout;
  if (!config || !config.url) return;

  const SEEN_COOKIE = 'yumtein_upsell_seen';

  const hasSeenOffer = () =>
    document.cookie.split('; ').some((entry) => entry.startsWith(`${SEEN_COOKIE}=`));

  /**
   * Diverts the shopper to the offer page on their way to checkout. Subscription carts,
   * carts already holding the offer product, carts below the offer discount's minimum spend, and
   * shoppers who have already seen the offer go straight through.
   */
  const interceptCheckout = (event) => {
    const trigger = event.target.closest?.('[name="checkout"]');
    if (!trigger || trigger.hasAttribute('data-upsell-skip') || hasSeenOffer()) return;

    event.preventDefault();
    event.stopPropagation();

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const skip =
          cart.item_count === 0 ||
          cart.total_price < config.minimumSpendCents ||
          cart.items.some(
            (item) =>
              item.selling_plan_allocation ||
              String(item.product_id) === String(config.productId),
          );

        window.location.href = skip ? '/checkout' : config.url;
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
  };

  document.addEventListener('click', interceptCheckout, true);
})();
